import {
  LabeledButton,
  LabeledButtonContent,
  LabeledButtonLabel,
} from "@babackapp/customer-ui/components/button";
import { DateSelect } from "@babackapp/customer-ui/components/date-select";
import { Label } from "@babackapp/customer-ui/components/label";
import {
  Option,
  OptionAction,
  OptionContent,
  OptionDescription,
  OptionIcon,
  OptionTitle,
} from "@babackapp/customer-ui/components/option";
import { RadioGroupItem } from "@babackapp/customer-ui/components/radio-group";
import { ChevronsUpDown, MailboxIcon } from "lucide-react";
import { Controller, type Control } from "react-hook-form";

type FormValues = {
  returnMode: string;
  pickupDate?: string;
  storeId?: string;
};

type Props = {
  control: Control<FormValues>;
  selected: boolean;
};

export function CarrierOption({ control, selected }: Props) {
  return (
    <Label htmlFor="carrier">
      <Option>
        <OptionIcon>
          <MailboxIcon />
        </OptionIcon>
        <OptionTitle>Faire mon retour par voie postale</OptionTitle>
        <OptionDescription>
          Imprimez votre étiquette, et remettez votre article au transporteur
        </OptionDescription>
        <OptionContent>
          {selected && (
            <Controller
              control={control}
              name="pickupDate"
              render={({ field }) => (
                <DateSelect
                  className="w-full"
                  selected={field.value ? new Date(field.value) : undefined}
                  onSelect={(date) =>
                    field.onChange(date ? date.toISOString().split("T")[0] : undefined)
                  }
                >
                  <LabeledButton variant="outline">
                    <LabeledButtonLabel>Date de retrait</LabeledButtonLabel>
                    <LabeledButtonContent>
                      {field.value
                        ? new Date(field.value).toLocaleDateString("fr-FR")
                        : "Aucune date sélectionnée"}
                    </LabeledButtonContent>
                    <ChevronsUpDown />
                  </LabeledButton>
                </DateSelect>
              )}
            />
          )}
        </OptionContent>
        <OptionAction>
          <RadioGroupItem value="carrier" id="carrier" />
        </OptionAction>
      </Option>
    </Label>
  );
}
